import React from 'react';
import { Field, Form, Formik } from 'formik';
import * as Yup from 'yup';
import { Button, Label } from 'edozvola-frontend-lib/dist/ui';
import { Col, FormGroup, Row } from 'reactstrap';
import { useNavigate, useParams } from 'react-router-dom';
import { ERRORS, messages } from 'app/config/constants';
import { showToast } from 'app/shared/util/toast.util';
import { toast } from 'react-toastify';
import { useDispatch } from 'react-redux';
import { initCaseFormChange, setFormChanged } from 'app/shared/reducers/case-form-change';
import { fetchLegalRemedyCodebookQuery } from 'app/edozvola/codebooks/codebooks.queries';
import {
  fetchCaseLegalRemedyQuery,
  saveCaseLegalRemedyMutation,
} from 'app/edozvola/cases/case-legal-remedy-form/case-legal-remedy-form.queries';
import { Loader } from 'app/shared/loader/loader';
import FormikValueObserver from 'app/shared/formik-observer/formik-observer';
import { PaginatedDropdown } from 'edozvola-frontend-lib/dist/ui/components/paginated-dropdown';
import { getCaseContext } from 'app/shared/util/context-util';

const CaseLegalRemedyForm = () => {
  const { id } = useParams<{ id: string }>();
  const { data: initialData, isLoading: initialDataLoading } = fetchCaseLegalRemedyQuery(id);
  const {
    data: legalRemedyOptions,
    isLoading: legalRemedyOptionsLoading,
    error: legalRemedyOptionsError,
  } = fetchLegalRemedyCodebookQuery();
  const { mutate: saveCaseLegalRemedy, isPending: isSaving } = saveCaseLegalRemedyMutation(id);
  const { sidebarItemPair } = getCaseContext();
  const navigate = useNavigate();
  const dispatch = useDispatch();

  if (legalRemedyOptionsError) {
    if (Object.values(ERRORS).includes(legalRemedyOptionsError.message)) {
      showToast(toast.error, legalRemedyOptionsError.message);
    } else {
      showToast(toast.error, ERRORS.GENERIC_ERROR);
    }
    navigate('/cases/');
  }

  const validation = Yup.object({
    legalRemedy: Yup.object().required(messages.MANDATORY_FIELD),
  });

  return (
    <>
      <Formik
        enableReinitialize={true}
        validateOnMount={true}
        initialValues={initialData}
        validationSchema={validation}
        onSubmit={values => saveCaseLegalRemedy(values)}
      >
        {({ errors, isValid, dirty, submitForm, setFieldValue, values }) => (
          <Form>
            <FormikValueObserver
              onChange={dirty => {
                if (dirty.dirty) {
                  dispatch(setFormChanged(true));
                } else {
                  dispatch(initCaseFormChange());
                }
              }}
            />
            <h5 className={'form-header'}>Pravni lijek</h5>
            {initialDataLoading && <Loader />}
            {!initialDataLoading && (
              <div>
                <Row>
                  <Col xs={12}>
                    <FormGroup>
                      <Label labelText={'Uputa o pravnom lijeku'} />
                      <Field
                        id="legalRemedy"
                        name="legalRemedy"
                        render={({ field }) => (
                          <PaginatedDropdown
                            onItemSelect={selectedOption => setFieldValue('legalRemedy', selectedOption[0])}
                            selected={field.value ?? []}
                            labelKey={'value'}
                            options={legalRemedyOptionsLoading ? [] : legalRemedyOptions}
                            placeholder={!sidebarItemPair?.readOnly && 'Odaberi uputu o pravnom lijeku'}
                            disabled={sidebarItemPair?.readOnly}
                            error={!sidebarItemPair?.readOnly && (errors.legalRemedy as string)}
                            showErrorMessage
                          />
                        )}
                      />
                    </FormGroup>
                  </Col>
                </Row>

                {!legalRemedyOptionsLoading && !initialData.readonly && !sidebarItemPair?.readonly && (
                  <div className="case-save-button">
                    <Button
                      color={'info'}
                      label={'Spremi'}
                      isLoading={isSaving}
                      size={'lg'}
                      onClick={submitForm}
                      disabled={!dirty || !isValid}
                    />
                  </div>
                )}
              </div>
            )}
          </Form>
        )}
      </Formik>
    </>
  );
};

export default CaseLegalRemedyForm;
